import { connect } from 'react-redux';

import PageSupportBlock from './page-support-block.component';
import { State } from 'widgets/redeem/root/root.reducers';
import { WIDGET_NAME } from '@sitegen/common/constants';

export interface IPageSupportBlockStoreProps {
    readonly faqUrl?: string;
    readonly shouldInheritStyles: boolean;
    readonly widgetName: WIDGET_NAME;
}

const mapStateToProps = (state: State): IPageSupportBlockStoreProps => ({
    faqUrl: state.config.links?.faq ?? '',
    shouldInheritStyles: state.config.shouldInheritStyles,
    widgetName: state.config.widgetName
});

export const PageSupportBlockContainer = connect(mapStateToProps)(PageSupportBlock);
